/** Execution resource nouns (tests/fixtures/activity-labels/resource.json). English equals the fixture exactly. */
export default {
  "resource.current_app": "Current app",
  "resource.screenshot": "Screenshot",
  "resource.focus": "Focus",
  "resource.click": "Click",
  "resource.typing": "Typing",
  "resource.drag": "Drag",
  "resource.paste": "Paste",
  "resource.copy": "Copy",
  "resource.look": "Look",
  "resource.scroll_up": "Scroll up",
  "resource.scroll_down": "Scroll down",
  "resource.scroll_left": "Scroll left",
  "resource.scroll_right": "Scroll right",
  "resource.target_app": "Target app",
} as const;
